import moment from 'moment-mini';
export const daysToSeconds = (days) => days * 24 * 60 * 60;
export const secondsToDays = (seconds) => Math.ceil(seconds / 24 / 60 / 60);
export const secondsTimeFormatted = (seconds) => moment.utc(seconds * 1000).format('HH:mm:ss');
export const ceilToXMinutes = (time, minutes) => {
    return time.set('minutes', Math.ceil(time.minutes() / minutes) * minutes);
};
